import { useEffect, useState } from 'react';

enum ScriptStatus {
  'loading',
  'idle',
  'ready',
  'error',
}

export const useScriptInjector = (
  srcPath: string,
  async: boolean,
  defer = false,
  id = "",
  config?: Function,
  setLoaded?: Function
): 'loading' | 'idle' | 'ready' | 'error' => {
  let [status, setStatus] = useState<keyof typeof ScriptStatus>('idle');

  useEffect(() => {
    if (!srcPath) {
      setStatus('idle');
      setLoaded && setLoaded(false);
      return;
    }
    let script: any = document.querySelector(`script[src="${srcPath}"]`);

    const handleScript = (e: any) => {
      setStatus(e.type === 'load' ? 'ready' : 'error');
      setLoaded && setLoaded(e.type === 'load' ? true : false)
    };

    if (!script) {
      script = document.createElement('script');
      script.setAttribute('type', 'application/javascript');
      script.setAttribute('src', srcPath);
      script.setAttribute('id', id);
      script.async = async;
      script.defer = defer;
      document.head.appendChild(script);
      script.addEventListener('load', handleScript);
      script.addEventListener('error', handleScript);
      if(config){
        config();
      }
    }

    script.addEventListener('load', handleScript);
    script.addEventListener('error', handleScript);

    return () => {
      script?.removeEventListener('load', handleScript);
      script?.removeEventListener('error', handleScript);
    };
  }, [srcPath, defer, async,config,id,setLoaded]);

  return status;
};
